import { render, staticRenderFns } from "./_DoPhone.vue?vue&type=template&id=76fb6fa4&scoped=true"
import script from "./_DoPhone.vue?vue&type=script&lang=js"
export * from "./_DoPhone.vue?vue&type=script&lang=js"
import style0 from "./_DoPhone.vue?vue&type=style&index=0&id=76fb6fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb6fa4",
  null
  
)

export default component.exports